// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"e5cd6a8e426b65053826","655":"5380faa532fa3c43bc2f"}[chunkId] + ".js";
};